// universignSigInit is loaded via ERB in the drawer partial
// (see `Rails.configuration.universign_iframe_endpoint/sig/embed.js`).
// This function assumes `universignSigInit` is already available on window.

export function initSignature(containerId, signerId, endpoint) {
  const configuration = { redirectionMode: 'IN' };
  // eslint-disable-next-line no-undef
  universignSigInit(containerId, signerId, configuration, endpoint);
}
